import "jquery-ui/themes/base/all";
import "themes/general/desktop";
import "themes/flysmarter/desktop";

import "components/desktop/cookie";

import "../../dep/google_analytics";
